import { useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import "./Marketing.css"
import AOS from "aos";
import "aos/dist/aos.css";

const Marketing = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            {/* <!-- no header, just hero with floating badge --> */}
<section class="sms-hero">
    <div class="hero-background"></div>
    <div class="floating-element"></div>
    <div class="floating-element"></div>
    <div class="content-container">
        <div class="hero-content">
            <div class="identifier-mini" data-aos="fade-down">
                <i class="fa-regular fa-message"></i> SMS MARKETING · ASK JEEVES IP · O'HANLON UPDATES
            </div>
            <h1 class="hero-title" data-aos="fade-up">Stay ahead of<br/>patent deadlines & news</h1>
            <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="100">Get O'Hanlon insights via text – only if you opt in.</p>
        </div>
    </div>
            </section>
{/* <!-- main sms card --> */}
<div className="content-container">
  <div className="sms-card" data-aos="fade-up">

    <div className="sms-bubble" data-aos="zoom-in">
      <i className="fa-regular fa-comment-dots"></i>{" "}
      “⚡ O'Hanlon alert: provisional deadline reminder for Alex – 2 weeks left.
      Reply HELP or STOP.”
    </div>

    <h2>
      <i
        className="fa-regular fa-circle-question"
        style={{ color: "#1D3A90" }}
      ></i>{" "}
      Why SMS from Ask Jeeves IP?
    </h2>

    <ul className="feature-list">
      <li>
        <i className="fa-regular fa-bell"></i>{" "}
        <strong>Critical patent reminders:</strong> 12-month provisional
        deadlines, office action responses, maintenance fees.
      </li>

      <li>
        <i className="fa-regular fa-flask"></i>{" "}
        <strong>O'Hanlon strategy flashes:</strong> weekly tips from our
        attorneys on claim drafting and prior art.
      </li>

      <li>
        <i className="fa-regular fa-clock"></i>{" "}
        <strong>Real-time updates:</strong> your patent application status
        changes (if you connect your USPTO account).
      </li>
    </ul>

    <h2>
      <i className="fa-regular fa-mobile"></i> Frequency & Opt-in
    </h2>

    <p>
      By providing your mobile number, you agree to receive recurring
      automated promotional and personalized patent alerts from Ask Jeeves
      IP (O'Hanlon division). Consent is not a condition of purchase. Msg &
      data rates may apply. Text HELP for help, STOP to cancel.
    </p>

    <div className="opt-well" data-aos="flip-up">
      <i
        className="fa-regular fa-hand-point-up fa-2xl"
        style={{
          color: "#54A6E9",
          fontSize: "2.5rem",
          marginBottom: "1rem",
          display: "block"
        }}
      ></i>

      <p
        style={{
          fontSize: "1.5rem",
          fontWeight: 600,
          margin: "0.5rem 0"
        }}
      >
        How to subscribe
      </p>

      <p>
        Text <span className="opt-code">JOIN</span> to{" "}
        <strong>+1 (833) 227-5642</strong> or check the SMS box during
        registration. You can also opt in via your account dashboard.
      </p>
    </div>

    <div className="compliance-card">
      <h3
        style={{
          color: "#0B1E4A",
          marginTop: 0,
          display: "flex",
          alignItems: "center",
          gap: "10px"
        }}
      >
        <i className="fa-regular fa-scale-balanced"></i> Your privacy &
        compliance (TCPA / 10DLC)
      </h3>

      <p>
        We are registered with The Campaign Registry (10DLC) and comply
        with CTIA guidelines. We never share your number with third
        parties for their own marketing. You can opt out anytime by
        replying STOP; you will receive a final confirmation text.
      </p>

      <p>
        <strong>Message frequency:</strong> up to 8 messages per month,
        but typically 2-4. For support, text HELP or email
        sms-support@askjeevesip.tech.
      </p>
    </div>

    <h2>
      <i className="fa-regular fa-message"></i> Example messages you may
      receive
    </h2>

    <ul className="example-messages">
      <li>
        <i className="fa-regular fa-message"></i>{" "}
        “O'Hanlon tip: when describing software inventions, include
        flowcharts to strengthen 112. Reply TIP for more.”
      </li>

      <li>
        <i className="fa-regular fa-message"></i>{" "}
        “Your patent application 17/890,123 has been published. Check
        your dashboard. (no reply needed)”
      </li>

      <li>
        <i className="fa-regular fa-message"></i>{" "}
        “Reminder: Your O'Hanlon attorney session is tomorrow at 2pm
        ET. Reply CONFIRM or RESCHEDULE.”
      </li>
    </ul>

    <h2>
      <i className="fa-regular fa-circle-stop"></i> STOP / HELP
      instructions
    </h2>

    <p>
      To stop receiving messages, reply STOP to any text or click
      unsubscribe in your account. For additional help, reply HELP or
      contact 1-833-ASK-JVIP. We will respond within 2 hours during
      business days.
    </p>

    <hr
      style={{
        margin: "3rem 0",
        border: "1px solid #e5ecf5"
      }}
    />

    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "2rem",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >
      <div>
        <i
          className="fa-regular fa-envelope"
          style={{ color: "#1D3A90" }}
        ></i>{" "}
        <strong>sms-privacy@askjeevesip.tech</strong>
      </div>

      <div>
        <i
          className="fa-regular fa-file-lines"
          style={{ color: "#1D3A90" }}
        ></i>{" "}
        SMS Terms are part of our Terms of Use
      </div>

      {/* 
      <a href="#" className="btn btn-primary">
        <i className="fa-regular fa-bell"></i> Subscribe now
      </a> 
      */}
    </div>

  </div>
            </div>
            <Footer />
        </>
    )
}

export default Marketing;